import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const FooterStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      backgroundColor: theme.palette.primary.main,
      flexDirection: "row",
      padding: "20px",
      display: "flex",
      flexWrap: "wrap",
      color: "#FFFFFF",
      width: "auto",
      [theme.breakpoints.up("md")]: {
        marginLeft: "220px",
      },
    },
    externalFooter: {
      backgroundColor: theme.palette.primary.main,
      flexDirection: "row",
      padding: "20px",
      display: "flex",
      flexWrap: "wrap",
      color: "#FFFFFF",
      width: "100%",
      position: "fixed",
      bottom: "0",
    },
    button: {
      justifyContent: "end",
    },

    label: {
      color: "white",
    },
    test: {
      color: theme.palette.secondary.main,
      fontSize: "14px",
      fontWeight: "600",
    },
    input: {
      paddingBottom: "5px",
    },
    typography: {
      fontSize: 14,
    },
    title: {
      fontSize: 16,
      color: theme.palette.secondary.main,
      fontWeight: "bold",
    },
    subtitle: {
      fontSize: 14,
      color: "#A3A3A3",
    },
    link: {
      cursor: "pointer",
    },
    boxtextField: {
      width: "100%",
      height: 68.5,
    },
    boxIcon: {
      width: 200,
      height: 35.11,
    },
    boxAddress: {
      width: 174,
      height: 96,
    },
    boxsocial: {
      width: 60,
      height: 44,
    },
    boxfooterEnd: {
      display: "flex",
      flexWrap: "wrap",
    },
    root: {
      "& .MuiInputBase-input": {
        color: "#fff", // Text color
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: "#fff8", // Semi-transparent underline
      },
      "& .MuiInput-underline:hover:before": {
        borderBottomColor: "#fff", // Solid underline on hover
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "#fff", // Solid underline on focus
      },
    },
    hide: {
      display: "none",
    },
  }),
);
